import React from 'react';
import { Dialog, Button } from '@mui/material';
import { fontSize, palette } from '../../index';

interface DeleteConfirmationDialogProps {
  open: boolean;
  onClose: (e: any) => void;
  onConfirm: (e: any) => void;
  message: React.ReactNode;
}

export const DeleteConfirmationDialog = ({
  open,
  onClose,
  onConfirm,
  message,
}: DeleteConfirmationDialogProps) => {
  return (
    <Dialog open={open} onClose={onClose}>
      <div className="workspace-remove-modal" style={{ height: 'auto' }}>
        {/* Confirmation message */}
        <div className="workspace-remove-modalContent-p">
          <p
            style={{
              fontSize: fontSize.medium,
              color: palette.primary.contrastText,
            }}
          >
            {message}
          </p>
        </div>

        {/* Buttons */}
        <div className="workspace-modal-buttons">
          <Button
            sx={{
              backgroundColor: 'white',
              border: '1px solid gray',
              marginLeft: '8px',
              width: '105px',
              fontSize: fontSize.medium,
              boxShadow: 'none',
              '&:hover': {
                backgroundColor: 'gray',
                color: 'white',
              },
            }}
            variant="contained"
            onClick={onClose}
          >
            Cancel
          </Button>
          <Button
            sx={{
              backgroundColor: 'white',
              border: '1px solid gray',
              marginLeft: '8px',
              width: '105px',
              fontSize: fontSize.medium,
              boxShadow: 'none',
              '&:hover': {
                backgroundColor: 'red',
                color: 'white',
                border: '1px solid red',
              },
            }}
            variant="contained"
            onClick={onConfirm}
          >
            Delete
          </Button>
        </div>
      </div>
    </Dialog>
  );
};
